<template>
  <div class="c-table" ref="comparetable">
    <Spin size="large" fix v-if="loading" />
    <div class="add-mater" v-if="compares.length > 6" :class="{ 'a-mater-disabled': compares.length > 5 }">
      <Icon type="ios-add" size="32" color="#fff" @click="$emit('on-add')" />
    </div>

    <Viewport v-if="isShowTable" v-model="tableHeight">
      <el-table
        ref="tableTreeRef"
        border
        row-key="id"
        :data="data"
        :height="tableHeight - 15"
        :span-method="arraySpanMethod"
        :tree-props="{ children: 'children' }"
      >
        <el-table-column prop="name" min-width="160">
          <template slot="header">
            <div class="custom-head-center">
              <span>对比指标</span>
              <Button type="primary" icon="md-download" :disabled="!compares.length" class="g-pull-right" @click="$emit('on-export')">
                数据导出
              </Button>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div class="custom-head">
              <span></span>
              <span>参照条件</span>
              <!-- <Button class="close-btn" v-if="zero" type="error" size="small" icon="md-close" shape="circle" ghost @click="$emit('on-delete', 0)"></Button> -->
              <Icon class="close-btn" type="ios-close-circle-outline" v-if="zero" @click="$emit('on-delete', 0)" />
              <span v-else></span>
            </div>
          </template>
          <el-table-column align="center">
            <template slot="header">
              <dl v-if="zero" class="custom-head-mater">
                <dt>{{ compares[0].imageName }}</dt>
                <dd>{{ compares[0].beginTime }}至{{ compares[0].endTime }}</dd>
                <dd>平台：{{ compares[0].platform | getPlatform }}</dd>
                <dd>媒体：{{ media(compares[0].mediaId) }}</dd>
              </dl>
              <dl v-else class="custom-select-mater">
                <dt><Button type="primary" @click="$emit('on-add')">待选择素材</Button></dt>
              </dl>
            </template>
            <el-table-column prop="refrence" label="具体数值" align="center" min-width="160"> </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div class="custom-head">
              <Tooltip v-if="one" content="转为参照条件" placement="top" theme="light" transfer class="arrow-tool">
                <Button type="text" size="small" icon="md-arrow-back" shape="circle" @click="$emit('on-convert', 1)"></Button>
              </Tooltip>
              <span v-else></span>
              <span>对比1</span>
              <Icon class="close-btn" type="ios-close-circle-outline" v-if="one" @click="$emit('on-delete', 1)" />
              <span v-else></span>
            </div>
          </template>
          <el-table-column align="center">
            <template slot="header">
              <dl v-if="one" class="custom-head-mater">
                <dt>{{ compares[1].imageName }}</dt>
                <dd>{{ compares[1].beginTime }}至{{ compares[1].endTime }}</dd>
                <dd>平台：{{ compares[1].platform | getPlatform }}</dd>
                <dd>媒体：{{ media(compares[1].mediaId) }}</dd>
              </dl>
              <dl v-else class="custom-select-mater">
                <dt><Button type="primary" @click="$emit('on-add')">待选择素材</Button></dt>
              </dl>
            </template>
            <el-table-column prop="compared1" label="具体数值" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedDif1" label="具体差异" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedRate1" label="差异比例" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.comparedRate1">{{ scope.row.comparedRate1 | toPercentFixed }}</span>
                <span v-else></span>
                <span class="m-arrup">
                  <Icon v-if="scope.row.comparedRate1 > 0" type="md-arrow-up" color="#18b566" />
                  <Icon v-else-if="scope.row.comparedRate1 < 0" type="md-arrow-down" color="#ed4014" />
                  <Icon v-else-if="scope.row.comparedRate1 === 0" type="md-remove" color="#ccc" />
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div class="custom-head">
              <Tooltip v-if="two" content="转为参照条件" placement="top" theme="light" transfer class="arrow-tool">
                <Button type="text" size="small" icon="md-arrow-back" shape="circle" @click="$emit('on-convert', 2)"></Button>
              </Tooltip>
              <span v-else></span>
              <span>对比2</span>
              <Icon class="close-btn" type="ios-close-circle-outline" v-if="two" @click="$emit('on-delete', 2)" />
              <span v-else></span>
            </div>
          </template>
          <el-table-column align="center">
            <template slot="header">
              <dl v-if="two" class="custom-head-mater">
                <dt>{{ compares[2].imageName }}</dt>
                <dd>{{ compares[2].beginTime }}至{{ compares[2].endTime }}</dd>
                <dd>平台：{{ compares[2].platform | getPlatform }}</dd>
                <dd>媒体：{{ media(compares[2].mediaId) }}</dd>
              </dl>
              <dl v-else class="custom-select-mater">
                <dt><Button type="primary" @click="$emit('on-add')">待选择素材</Button></dt>
              </dl>
            </template>
            <el-table-column prop="compared2" label="具体数值" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedDif2" label="具体差异" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedRate2" label="差异比例" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.comparedRate2">{{ scope.row.comparedRate2 | toPercentFixed }}</span>
                <span v-else></span>
                <span class="m-arrup">
                  <Icon v-if="scope.row.comparedRate2 > 0" type="md-arrow-up" color="#18b566" />
                  <Icon v-else-if="scope.row.comparedRate2 < 0" type="md-arrow-down" color="#ed4014" />
                  <Icon v-else-if="scope.row.comparedRate2 === 0" type="md-remove" color="#ccc" />
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div class="custom-head">
              <Tooltip v-if="three" content="转为参照条件" placement="top" theme="light" transfer class="arrow-tool">
                <Button type="text" size="small" icon="md-arrow-back" shape="circle" @click="$emit('on-convert', 3)"></Button>
              </Tooltip>
              <span v-else></span>
              <span>对比3</span>
              <Icon class="close-btn" type="ios-close-circle-outline" v-if="three" @click="$emit('on-delete', 3)" />
              <span v-else></span>
            </div>
          </template>
          <el-table-column align="center">
            <template slot="header">
              <dl v-if="three" class="custom-head-mater">
                <dt>{{ compares[3].imageName }}</dt>
                <dd>{{ compares[3].beginTime }}至{{ compares[3].endTime }}</dd>
                <dd>平台：{{ compares[3].platform | getPlatform }}</dd>
                <dd>媒体：{{ media(compares[3].mediaId) }}</dd>
              </dl>
              <dl v-else class="custom-select-mater">
                <dt><Button type="primary" @click="$emit('on-add')">待选择素材</Button></dt>
              </dl>
            </template>
            <el-table-column prop="compared3" label="具体数值" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedDif3" label="具体差异" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedRate3" label="差异比例" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.comparedRate3">{{ scope.row.comparedRate3 | toPercentFixed }}</span>
                <span v-else></span>
                <span class="m-arrup">
                  <Icon v-if="scope.row.comparedRate3 > 0" type="md-arrow-up" color="#18b566" />
                  <Icon v-else-if="scope.row.comparedRate3 < 0" type="md-arrow-down" color="#ed4014" />
                  <Icon v-else-if="scope.row.comparedRate3 === 0" type="md-remove" color="#ccc" />
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div class="custom-head">
              <Tooltip v-if="four" content="转为参照条件" placement="top" theme="light" transfer class="arrow-tool">
                <Button type="text" size="small" icon="md-arrow-back" shape="circle" @click="$emit('on-convert', 4)"></Button>
              </Tooltip>
              <span v-else></span>
              <span>对比4</span>
              <Icon class="close-btn" type="ios-close-circle-outline" v-if="four" @click="$emit('on-delete', 4)" />
              <span v-else></span>
            </div>
          </template>
          <el-table-column align="center">
            <template slot="header">
              <dl v-if="four" class="custom-head-mater">
                <dt>{{ compares[4].imageName }}</dt>
                <dd>{{ compares[4].beginTime }}至{{ compares[4].endTime }}</dd>
                <dd>平台：{{ compares[4].platform | getPlatform }}</dd>
                <dd>媒体：{{ media(compares[4].mediaId) }}</dd>
              </dl>
              <dl v-else class="custom-select-mater">
                <dt><Button type="primary" @click="$emit('on-add')">待选择素材</Button></dt>
              </dl>
            </template>
            <el-table-column prop="compared4" label="具体数值" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedDif4" label="具体差异" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedRate4" label="差异比例" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.comparedRate4">{{ scope.row.comparedRate4 | toPercentFixed }}</span>
                <span v-else></span>
                <span class="m-arrup">
                  <Icon v-if="scope.row.comparedRate4 > 0" type="md-arrow-up" color="#18b566" />
                  <Icon v-else-if="scope.row.comparedRate4 < 0" type="md-arrow-down" color="#ed4014" />
                  <Icon v-else-if="scope.row.comparedRate4 === 0" type="md-remove" color="#ccc" />
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center">
          <template slot="header">
            <div class="custom-head">
              <Tooltip v-if="five" content="转为参照条件" placement="top" theme="light" transfer class="arrow-tool">
                <Button type="text" size="small" icon="md-arrow-back" shape="circle" @click="$emit('on-convert', 5)"></Button>
              </Tooltip>
              <span v-else></span>
              <span>对比5</span>
              <Icon class="close-btn" type="ios-close-circle-outline" v-if="five" @click="$emit('on-delete', 5)" />
              <span v-else></span>
            </div>
          </template>
          <el-table-column align="center">
            <template slot="header">
              <dl v-if="five" class="custom-head-mater">
                <dt>{{ compares[5].imageName }}</dt>
                <dd>{{ compares[5].beginTime }}至{{ compares[5].endTime }}</dd>
                <dd>平台：{{ compares[5].platform | getPlatform }}</dd>
                <dd>媒体：{{ media(compares[5].mediaId) }}</dd>
              </dl>
              <dl v-else class="custom-select-mater">
                <dt><Button type="primary" @click="$emit('on-add')">待选择素材</Button></dt>
              </dl>
            </template>
            <el-table-column prop="compared5" label="具体数值" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedDif5" label="具体差异" align="center" min-width="80"> </el-table-column>
            <el-table-column prop="comparedRate5" label="差异比例" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.comparedRate5">{{ scope.row.comparedRate5 | toPercentFixed }}</span>
                <span v-else></span>
                <span class="m-arrup">
                  <Icon v-if="scope.row.comparedRate5 > 0" type="md-arrow-up" color="#18b566" />
                  <Icon v-else-if="scope.row.comparedRate5 < 0" type="md-arrow-down" color="#ed4014" />
                  <Icon v-else-if="scope.row.comparedRate5 === 0" type="md-remove" color="#ccc" />
                </span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </Viewport>
    <div v-if="noData" class="c-nodata">
      <Icon type="ios-filing-outline" :size="88" color="#dedede" />
      <h3>选择的素材没有数据，无法完成对比</h3>
    </div>
  </div>
</template>
<script>
import { timeout, isEmpty } from '@/common/js/utils'

export default {
  name: 'CompareTable',
  props: {
    isShowTable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    noData: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    compares: {
      type: Array,
      required: true
    },
    mediaData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    media() {
      const filterMedia = (id) => {
        return this.mediaData.filter((ret) => ret.id === id)
      }
      return (id) => {
        if (id <= 0 || isEmpty(id)) return '全部'
        const media = filterMedia(Number(id)).pop()
        return media ? media.name : '未知'
      }
    },
    zero() {
      return this.compares.length > 0
    },
    one() {
      return this.compares.length > 1
    },
    two() {
      return this.compares.length > 2
    },
    three() {
      return this.compares.length > 3
    },
    four() {
      return this.compares.length > 4
    },
    five() {
      return this.compares.length > 5
    }
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (['Basic', 'PlayData', 'RetainRate', 'DayLtv'].includes(row.key)) {
        if (!columnIndex) return [1, 17]
        else return [0, 0]
      }
    },
    // 触发所有展开图标的click事件
    expandAll() {
      // 获取点击的箭头元素
      const els = document.getElementsByClassName('el-table__expand-icon')
      for (let i = 0; i < els.length; i++) {
        els[i].click()
      }
    },
    // 展开所有下级
    unFoldAll() {
      this.isShowTable = false
      this.$nextTick(() => {
        this.isShowTable = true
        timeout(300).then(() => {
          this.expandAll()
        })
      })
    },
    // 收起所有下级
    foldAll() {
      this.isShowTable = false
      this.$nextTick(() => {
        this.isShowTable = true
      })
    }
  },
  data() {
    return {
      tableHeight: 600
    }
  },
  watch: {
    data(nVal) {
      this.$nextTick(() => {
        this.expandAll()
        // this.height = this.$refs.comparetable.offsetHeight
        // this.$refs.tableTreeRef.doLayout()
      })
    }
  },
  filters: {
    getPlatform(cellValue) {
      cellValue = Number(cellValue)
      if (cellValue === 1) return '安卓'
      else if (cellValue === 2) return 'iOS'
      else return '全部'
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  width: 100%;
  background-color: #fff;

  ::v-deep .el-table th {
    user-select: unset;

    .cell {
      max-height: unset !important;
    }
  }

  .custom-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0;
    color: #666;

    .arrow-tool {
      display: flex;
      align-items: center;
    }

    .close-btn {
      color: red;
      font-size: 24px;
      cursor: pointer;
    }
  }

  .custom-head-center {
    font-size: 14px;
    font-weight: 600;
    color: #666;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .custom-head-mater {
    font-size: 14px;

    dt {
      font-weight: 600;
      color: #333;
    }

    dd {
      color: #999;
      font-size: 12px;
    }
  }

  .custom-select-mater {
    font-size: 14px;

    dt {
      font-weight: 600;
      color: #999;
    }
  }

  ::v-deep .ivu-tooltip,
  ::v-deep .ivu-tooltip-rel {
    padding: 0;
    line-height: unset;
  }

  .add-mater {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #2d8cf0;
    border-radius: 30px;
    position: absolute;
    right: 10px;
    top: 6px;
    z-index: 1024;

    &:hover {
      background-color: #57a3f3;
    }

    &.a-mater-disabled {
      background-color: #dedede;
      cursor: not-allowed;
      user-select: none;
      pointer-events: none;
    }
  }

  .m-arrup {
    margin-right: 4px;
  }

  .c-nodata {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #c3c3c3;
    font-size: 12px;
  }

  /* 表格表头 */
  ::v-deep.el-table td,
  ::v-deep.el-table th {
    padding: 6px 0;
  }

  /* 表格背景 */
  ::v-deep.el-table th {
    background-color: #f2f2f2;
  }

  ::v-deep.el-table .cell {
    font-size: 12px;
    width: 100%;
    display: flex;

    .custom-head-mater {
      width: 100%;
    }
  }
}
</style>
